import { render } from "./bread_crumbs.vue?vue&type=template&id=af7cdd70"
import script from "./bread_crumbs.vue?vue&type=script&lang=js"
export * from "./bread_crumbs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__